import React from 'react';
const ModalTitle = () => {
  return (
    <div className="test-modal-title-wrapper">
      <div className="test-modal-title-wrapper_header">Welcome to Turing</div>
    </div>
  );
};

export default ModalTitle;
